import store from '../store'
import axios from "axios";
import { isObjEmpty, SortArrayByObjProps } from "../js/helpers"
const qs = require('qs');
const DOMAIN1 = "https://newapi.quiktrak.co/";
const DOMAIN3 = "https://test4.m2mdata.co/";
const DOMAIN4 = "https://nominatim.sinopacific.com.ua/";
const DOMAIN5 = "https://upload.quiktrak.co/"
const DOMAIN6 = "https://activation.gps-secure.co/"
const DOMAIN7 = "https://app.quikprotect.co/"
export const ApiMethods = {
	DOMAIN1,

	LOGIN: DOMAIN1 + 'Quikloc8/V1/user/Auth3',
	LOGOUT: DOMAIN1 + 'QuikProtect/V1/Client/Logoff',
	REFRESH_PUSH_TOKEN: DOMAIN1 + "QuikTrak/V1/User/RefreshToken",
	GET_NEW_NOTIFICATIONS: DOMAIN1 + "Quikloc8/V1/asset/Alarms",
	SET_NOTIFICATION_STATUS: DOMAIN1 + "Installer/V1/Client/Notification",

	RESET_PASSWORD: DOMAIN1 + 'QuikTrak/V1/User/Password',
	ACCOUNT_EDIT: DOMAIN1 + 'QuikProtect/V1/Client/AccountEdit',
	GET_CREDIT_BALANCE: DOMAIN1 + 'QuikProtect/V1/Client/Balance',
	CREDITS_TRANSFER: DOMAIN1 + 'Quiktrak/V1/Credits/Transfer',
	CREDITS_TRANSFER_HISTORY: DOMAIN1 + 'Quiktrak/V1/Credits/History',
	//GET_ASSET_LIST: DOMAIN1 + 'Installer/V1/Client/GetAssetList',
	GET_ASSET_LIST: DOMAIN1 + 'QuikTrak/V2/Asset/GetList',
	ASSET_EDIT: DOMAIN1 + 'QuikTrak/V2/Asset/Edit',
	ASSET_TRANSFER: DOMAIN1 + 'QuikTrak/V2/Asset/Transport2Customer',
	GET_ASSET_LOCATION: DOMAIN1 + 'Installer/V1/Client/LivePostion',
	GET_ASSET_LAST_ALARMS: DOMAIN1 + 'Installer/V1/Client/GetTop5Alarms',
	GET_ASSET_ALARM_HISTORY: DOMAIN1 + 'Installer/V1/Client/GetAlarms',
	ASSET_DEACTIVATE: DOMAIN1 + 'Common/V1/Activation/DeActivate',
	GET_SSP: DOMAIN1 + 'Common/v1/Activation/SSP',
	GET_ASSET_INFO: DOMAIN1 + 'Common/v1/Activation/GetAssetsInfo',
	SET_INPUT_CONFIG: DOMAIN1 + 'Installer/V1/Client/GPIO',
	SET_POWER_LEVELS: DOMAIN1 + 'Installer/V1/Client/PowerLevels',
	SEND_COMMAND_POSITION: DOMAIN1 + 'Installer/V1/Client/ProtectPostion2',
	SEND_COMMAND_STATUS: DOMAIN1 + 'Installer/V1/Client/Status2',
	SEND_COMMAND_IMMOBILISE: DOMAIN1 + 'Installer/V1/Client/Immobilise2',
	SEND_COMMAND_UNIMMOBILISE: DOMAIN1 + 'Installer/V1/Client/Unimobilise2',
	SEND_COMMAND_ACCVOLTAGE_ON: DOMAIN1 + 'Installer/V1/Client/AccVoltageOn',
	SEND_COMMAND_ACCVOLTAGE_OFF: DOMAIN1 + 'Installer/V1/Client/AccVoltageOff',
	SEND_COMMAND_CONFIG: DOMAIN1 + 'Installer/V1/Client/Config',

	CHANGE_NOTIFICATION_STATUS: DOMAIN1 + 'Installer/V1/Client/Notification',

	GET_DASHBOARD: DOMAIN1 + 'Quiktrak/v1/Report/Dashboard',
	GET_USAGE_OVERVIEW: DOMAIN1 + 'Quiktrak/v1/Report/UsageOverview',
	GET_DASHBOARD2: DOMAIN1 + 'Quikloc8/V1/User/Dashboard',
	GET_ACTIVATED_DEVICES: DOMAIN1 + 'QuikTrak/V1/Report/GetDevicesSold2',

	GET_CUSTOMERS: DOMAIN1 + 'Quiktrak/V2/Customer/GetList',
	GET_PRE_EDIT_CUSTOMER_INFO: DOMAIN1 + 'Quiktrak/V2/Customer/PreEdit',
	CUSTOMER_RESET_PASSWORD: DOMAIN1 + 'Quikloc8/V1/SubDealer/ResetPassword',
	CUSTOMER_DELETE: DOMAIN1 + 'Quiktrak/V2/Customer/Remove',
	CUSTOMER_DISABLE: DOMAIN1 + 'Quiktrak/V2/Customer/Disable',
	CUSTOMER_ENABLE: DOMAIN1 + 'Quiktrak/V2/Customer/Enable',
	CUSTOMER_EDIT: DOMAIN1 + 'Quiktrak/V2/Customer/Edit',
	SEND_CUSTOMER_REG_LETTER: DOMAIN1 + 'Common/V1/Activation/DealerRegistion',
	SEND_ASSET_ACTIVATION_LETTER: DOMAIN1 + 'Common/V1/Activation/ReSendActivation',
	GET_ACTIVATION_HISTORY: DOMAIN1 + 'Common/V1/Activation/QueryHistory',

	GET_SIM_STATUS: DOMAIN3 + 'JT/Sim/Query',
	GET_SMS_HISTORY: DOMAIN3 + 'JT/SMS/History',
	SIM_SET_SUSPEND: DOMAIN3 + 'JT/Sim/Suspend',
	SIM_SET_RESUME: DOMAIN3 + 'JT/Sim/Resume',
	SIM_SET_TERMINATE: DOMAIN3 + 'JT/Sim/Terminate',
	GET_HLR_INFO: DOMAIN3 + 'JT/Sim/GetHlrInfo',
	GET_SIM_CURRENT_SESSION: DOMAIN3 + 'JT/Sim/GetActiveSession',
	GET_SIM_SESSIONS: DOMAIN3 + 'JT/Sim/GetSessions',
	SIM_REPLACE: DOMAIN1 + 'Common/V1/Activation/ReplaceSim',
	SIM_SEND_COMMAND: DOMAIN1 + 'QuikData/V1/Command/SendByType',
	SIM_GET_COMMANDS: DOMAIN1 + 'QuikData/V1/Command/GetCommandTypeList4Clients',
	GET_CSP: DOMAIN3 + 'JT/ServiceProfile/Query',
	GET_SIM_OWNERS: DOMAIN3 + 'Service/Organize/Query',
	SIM_SET_SERVICE_PROFILE: DOMAIN3 + 'JT/Sim/SetSimServiceProfile',
	SIM_MOVE: DOMAIN3 + 'JT/Sim/Transfer',
	FORCE_RECONNECT: DOMAIN3 + 'JT/Sim/Reboot',
	GET_SIM_LOCATION: DOMAIN3 + 'JT/Sim/QueryLBSInfo',



	GET_ADDRESS_BY_COORDS: DOMAIN4 + 'reverse',

	ASSET_IMAGE_URL: DOMAIN5 + 'Attachment/images/',
	GO_FOR_SUPPORT: 'https://support.agent.gps-secure.co/',
	GO_FOR_ACTIVATION: DOMAIN6,
	GO_FOR_INSTALL_NOTICE: DOMAIN7,
}
//https://newapi.quiktrak.co/Quikloc8/V1/
// asset/Alarms
//https://newapi.quiktrak.co/QuikProtect/V1/Client/
// Logoff
//https://newapi.quiktrak.co/QuikProtect/V1/Client/
//API_URL.GET_BALANCE = API_DOMIAN3 + "Balance";
//API_URL.URL_GET_PROTECT_POSITION = API_DOMIAN1 + "Client/ProtectPostion2";
//API_URL.URL_SET_POWER_LEVELS_CONFIG = API_DOMIAN1 + "CLIENT/PowerLevels";
//API_URL.URL_SET_INPUT_CONFIG = API_DOMIAN1 + "Client/GPIO";
//https://newapi.quiktrak.co/Quiktrak/V2/Customer/PreEdit
//https://newapi.quiktrak.co/Quiktrak/V1/User/QueryAcccount
//
// Quikloc8/V1/SubDealer/ResetPassword

function getAjaxRequestOptions({ url, method, data }) {
	const ajaxRequestOptions = {
		"url": url,
		"method": method,
		"timeout": 0,
		"headers": {
			"token": '00000000-0000-0000-0000-000000000000',
			"Content-Type": "application/x-www-form-urlencoded"
		},
		"data": data
	}

	return ajaxRequestOptions
}

export const QTAPI = {
	async Login(query) {
		try {
			const response = await axios.get(ApiMethods.LOGIN, { params: query });
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'LOGIN';
				store.commit('SET_ERROR', response.data)
				return false
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'LOGIN';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async Logout(query) {
		try {
			const response = await axios.get(ApiMethods.LOGOUT, { params: query });
			return response.data
			/* if (response.data.MajorCode === '000') {
			   return response.data.Data
			 }else{
			   response.data.method = 'LOGOUT';
			   store.commit('SET_ERROR', response.data)
			   return false
			 }*/
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'LOGOUT';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async RefreshPushToken(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.REFRESH_PUSH_TOKEN, data);
			console.log(response)
			/*if (response.data.MajorCode === '000') {
			  return response.data.Data
			}else{
			  response.data.method = 'LOGIN';
			  store.commit('SET_ERROR', response.data)
			  return false
			}*/
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'REFRESH_PUSH_TOKEN';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetNewNotifications(query) {
		try {
			const response = await axios.get(ApiMethods.GET_NEW_NOTIFICATIONS, { params: query });
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_NEW_NOTIFICATIONS';
				store.commit('SET_ERROR', response.data)
				return []
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_NEW_NOTIFICATIONS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SetNotificationStatus(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SET_NOTIFICATION_STATUS, data);
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SET_NOTIFICATION_STATUS';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SET_NOTIFICATION_STATUS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetAssetList(query) {
		try {
			const response = await axios.get(ApiMethods.GET_ASSET_LIST, { params: query });
			if (response.data && response.data.rows) {
				return response.data
			} else {
				response.data.method = 'GET_ASSET_LIST';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_ASSET_LIST';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async AssetEdit(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.ASSET_EDIT, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'ASSET_EDIT';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'ASSET_EDIT';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetCreditBalance(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_CREDIT_BALANCE, data);
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_CREDIT_BALANCE';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_CREDIT_BALANCE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async CreditsTransfer(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.CREDITS_TRANSFER, data);
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'CREDITS_TRANSFER';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'CREDITS_TRANSFER';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetCreditsTransferHistory(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.CREDITS_TRANSFER_HISTORY, data);
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'CREDITS_TRANSFER_HISTORY';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'CREDITS_TRANSFER_HISTORY';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async AssetTransfer(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.ASSET_TRANSFER, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'ASSET_TRANSFER';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'ASSET_TRANSFER';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SetInputConfig(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SET_INPUT_CONFIG, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SET_INPUT_CONFIG';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SET_INPUT_CONFIG';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SetPowerLevels(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SET_POWER_LEVELS, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SET_POWER_LEVELS';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SET_POWER_LEVELS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendCommandPosition(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_COMMAND_POSITION, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SEND_COMMAND_POSITION';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_COMMAND_POSITION';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async ChangeNotificationStatus(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.CHANGE_NOTIFICATION_STATUS, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'CHANGE_NOTIFICATION_STATUS';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'CHANGE_NOTIFICATION_STATUS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendCommandStatus(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_COMMAND_STATUS, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SEND_COMMAND_STATUS';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_COMMAND_STATUS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendCommandImmobilise(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_COMMAND_IMMOBILISE, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SEND_COMMAND_IMMOBILISE';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_COMMAND_IMMOBILISE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendCommandUnImmobilise(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_COMMAND_UNIMMOBILISE, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SEND_COMMAND_UNIMMOBILISE';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_COMMAND_UNIMMOBILISE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendCommandACCVoltageOn(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_COMMAND_ACCVOLTAGE_ON, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SEND_COMMAND_ACCVOLTAGE_ON';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_COMMAND_ACCVOLTAGE_ON';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendCommandACCVoltageOff(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_COMMAND_ACCVOLTAGE_OFF, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SEND_COMMAND_ACCVOLTAGE_OFF';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_COMMAND_ACCVOLTAGE_OFF';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendCommandConfig(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_COMMAND_CONFIG, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SEND_COMMAND_CONFIG';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_COMMAND_CONFIG';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetCustomers(query) {
		try {
			let cancelToken = axios.CancelToken.source()
			store.commit("SET_SEARCH_CANCEL_TOKEN", cancelToken)
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.GET_CUSTOMERS, {
				params: query,
				cancelToken: cancelToken.token
			});
			if (response.data && response.data.rows) {
				store.commit("SET_SEARCH_CANCEL_TOKEN", null)
				return response.data
			} else {
				response.data.method = 'GET_CUSTOMERS';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (axios.isCancel(e)) return { isCanceled: true }
			if (e && e.response && e.response.data) e.response.data.method = 'GET_CUSTOMERS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetPreEditCustomerInfo(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_PRE_EDIT_CUSTOMER_INFO, data);
			if (!response.data.MajorCode) {
				return response.data
			} else {
				response.data.method = 'GET_PRE_EDIT_CUSTOMER_INFO';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_PRE_EDIT_CUSTOMER_INFO';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async CustomerDelete(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.CUSTOMER_DELETE, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'CUSTOMER_DELETE';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_DELETE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async CustomerSuspend(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.CUSTOMER_DISABLE, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'CUSTOMER_DISABLE';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_DISABLE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async CustomerUnSuspend(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.CUSTOMER_ENABLE, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'CUSTOMER_ENABLE';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_ENABLE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async CustomerResetPassword(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.CUSTOMER_RESET_PASSWORD, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'CUSTOMER_RESET_PASSWORD';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_RESET_PASSWORD';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async CustomerEditInfo(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.CUSTOMER_EDIT, data);
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'CUSTOMER_EDIT';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_EDIT';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendRegLetter(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_CUSTOMER_REG_LETTER, data);
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'SEND_CUSTOMER_REG_LETTER';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_CUSTOMER_REG_LETTER';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetActivationHistory(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_ACTIVATION_HISTORY, data);
			if (response.data?.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_ACTIVATION_HISTORY';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_ACTIVATION_HISTORY';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SendAssetActivationLetter(query) {
		try {
			/*let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SEND_ASSET_ACTIVATION_LETTER, data );*/

			const response = await axios.get(ApiMethods.SEND_ASSET_ACTIVATION_LETTER, { params: query });

			if (response.data.MajorCode === '000' && response.data.Data !== 'Client type incorrect') {
				return response.data
			} else {
				response.data.method = 'SEND_ASSET_ACTIVATION_LETTER';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SEND_ASSET_ACTIVATION_LETTER';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},


	async GetAssetLocation(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_ASSET_LOCATION, data);
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_ASSET_LOCATION';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_ASSET_LOCATION';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	/*async GetSimLocation(query){
	  try {
		const options = {
		  "url": ApiMethods.GET_SIM_LOCATION,
		  "method": "POST",
		  "data": query
		}
		return new Promise((resolve, reject) => {
		  $.ajax(getAjaxRequestOptions(options)).done(function (response) {
			if(response.Data && response.Data.LbsLat){
			  resolve(response.Data)
			}else{
			  response.method = 'GET_SIM_LOCATION'
			  reject()
			}
		  }).fail(function (e){
			if(e && e.response && e.response.data) e.response.data.method = 'GET_SIM_LOCATION'
		   store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		  })
		})
  
	  } catch (e) {
		if(e && e.response && e.response.data) e.response.data.method = 'GET_SIM_LOCATION';
		store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
		throw e
	  }
	},*/

	async GetSimLocation(query) {
		try {
			let data = qs.stringify(query, { arrayFormat: 'brackets' })
			return new Promise(async (resolve, reject) => {
				const response = await axios.post(ApiMethods.GET_SIM_LOCATION, data, {
					headers: {
						'token': store.getters.RootToken
					}
				});

				if (response.data.Data && response.data.Data.LbsLat) {
					resolve(response.data.Data)
				} else {
					response.data.method = 'GET_SIM_LOCATION'
					store.commit('SET_ERROR', response.data)
					reject()
				}
			})

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_SIM_LOCATION';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async ForceReconnect(query) {
		try {
			const options = {
				"url": ApiMethods.FORCE_RECONNECT,
				"method": "POST",
				"data": query
			}
			return new Promise((resolve, reject) => {
				$.ajax(getAjaxRequestOptions(options)).done(function (response) {
					if (response.MajorCode == '000') {
						resolve(true)
					} else {
						response.method = 'FORCE_RECONNECT'
						reject()
					}
				}).fail(function (e) {
					if (e && e.response && e.response.data) e.response.data.method = 'FORCE_RECONNECT'
					store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
					throw e
				})
			})

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'FORCE_RECONNECT';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async AssetDeactivation(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.ASSET_DEACTIVATE, data);
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'ASSET_DEACTIVATE';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'ASSET_DEACTIVATE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetAssetLastAlarms(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.GET_ASSET_LAST_ALARMS, {
				params: query,
			});
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_ASSET_LAST_ALARMS';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_ASSET_LAST_ALARMS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetAssetAlarmHistory(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.GET_ASSET_ALARM_HISTORY, {
				params: query,
			});
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_ASSET_ALARM_HISTORY';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_ASSET_ALARM_HISTORY';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetSimStatus(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_SIM_STATUS, data, {
				headers: {
					'token': store.getters.RootToken
				}
			});

			if (!response.data.MajorCode) {
				return response.data
			} else {
				response.data.method = 'GET_SIM_STATUS';
				store.commit('SET_ERROR', response)
				return false
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_SIM_STATUS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetSmsHistory(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_SMS_HISTORY, data, {
				headers: {
					'token': store.getters.RootToken
				}
			});

			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_SMS_HISTORY';
				store.commit('SET_ERROR', response)
				return false
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_SMS_HISTORY';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SimSetSuspend(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SIM_SET_SUSPEND, data, {
				headers: {
					'token': store.getters.RootToken
				}
			});
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'SIM_SET_SUSPEND';
				store.commit('SET_ERROR', response)
				return false
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_SUSPEND';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SimSetResume(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SIM_SET_RESUME, data, {
				headers: {
					'token': store.getters.RootToken
				}
			});
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'SIM_SET_RESUME';
				store.commit('SET_ERROR', response)
				return false
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_RESUME';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SimSetTerminate(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SIM_SET_TERMINATE, data, {
				headers: {
					'token': store.getters.RootToken
				}
			});
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'SIM_SET_TERMINATE';
				store.commit('SET_ERROR', response)
				return false
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_TERMINATE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetHLRInfo(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.GET_HLR_INFO, {
				params: query,
				headers: {
					'token': store.getters.RootToken
				}
			});
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_HLR_INFO';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_HLR_INFO';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetSimCurrentSession(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.GET_SIM_CURRENT_SESSION, {
				params: query,
				headers: {
					'token': store.getters.RootToken
				}
			});
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_SIM_CURRENT_SESSION';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_SIM_CURRENT_SESSION';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetSimSessions(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.GET_SIM_SESSIONS, {
				params: query,
				headers: {
					'token': store.getters.RootToken
				}
			});
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_SIM_SESSIONS';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_SIM_SESSIONS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetSimCommandList(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.SIM_GET_COMMANDS, {
				params: query,
			});
			//console.log(response)
			if (response.data && Array.isArray(response.data)) {
				return response.data
			} else {
				response.data.method = 'SIM_GET_COMMANDS';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SIM_GET_COMMANDS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async SimSendCommand(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.SIM_SEND_COMMAND, data, {
				headers: {
					'token': store.getters.RootToken
				}
			});
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'SIM_SEND_COMMAND';
				store.commit('SET_ERROR', response)
				return false
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SIM_SEND_COMMAND';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async ResetPassword(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.RESET_PASSWORD, {
				params: query,
			});
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data
			} else {
				response.data.method = 'RESET_PASSWORD';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'RESET_PASSWORD';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async AccountEdit(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.ACCOUNT_EDIT, {
				params: query,
			});
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'ACCOUNT_EDIT';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'ACCOUNT_EDIT';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async GetAddressByCoords(params) {
		let data = {
			format: 'json',
			addressdetails: '1',
			lat: params.latitude,
			lon: params.longitude,
		}
		try {
			const response = await axios.get(ApiMethods.GET_ADDRESS_BY_COORDS, {
				params: data,
			});
			return response.data
		} catch (e) {
			/*commit('SET_ERROR', e)
			throw e*/
			if (e && e.response && e.response.data) e.response.data.method = 'GET_ADDRESS_BY_COORDS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async SetCustomer(query) {
		try {
			const options = {
				"url": ApiMethods.SIM_MOVE,
				"method": "POST",
				"data": query
			}
			return new Promise((resolve, reject) => {
				$.ajax(getAjaxRequestOptions(options)).done(function (response) {
					if (response.MajorCode == '000') {
						resolve(true)
					} else {
						response.method = 'SIM_MOVE'
						reject()
					}
				}).fail(function (e) {
					if (e && e.response && e.response.data) e.response.data.method = 'SIM_MOVE'
					store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
					throw e
				})
			})

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_SERVICE_PROFILE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async SetCSP(query) {
		try {
			const options = {
				"url": ApiMethods.SIM_SET_SERVICE_PROFILE,
				"method": "POST",
				"data": query
			}
			return new Promise((resolve, reject) => {
				$.ajax(getAjaxRequestOptions(options)).done(function (response) {
					if (response.MajorCode == '000') {
						resolve(true)
					} else {
						response.method = 'SIM_SET_SERVICE_PROFILE'
						reject()
					}
				}).fail(function (e) {
					if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_SERVICE_PROFILE'
					store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
					throw e
				})
			})

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_SERVICE_PROFILE';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async GetSimOwners(query) {
		try {
			const options = {
				"url": ApiMethods.GET_SIM_OWNERS,
				"method": "POST",
				"data": query
			}
			return new Promise((resolve, reject) => {
				$.ajax(getAjaxRequestOptions(options)).done(function (response) {
					if (response) {
						resolve(response)
					} else {
						response.method = 'GET_SIM_OWNERS'
						reject()
					}
				}).fail(function (e) {
					if (e && e.response && e.response.data) e.response.data.method = 'GET_SIM_OWNERS'
					store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
					throw e
				})
			})

		} catch (e) {

			if (e && e.response && e.response.data) e.response.data.method = 'GET_SIM_OWNERS';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	/*async GetCSP(query){
	  try {
		const options = {
		  "url": ApiMethods.GET_CSP,
		  "method": "POST",
		  "data": query
		}
		return new Promise((resolve, reject) => {
		  $.ajax(getAjaxRequestOptions(options)).done(function (response) {
			if(response.MajorCode == '000'){
			  resolve(response)
			}else{
			  response.method = 'GET_CSP'
			  reject()
			}
		  }).fail(function (e){
			if(e && e.response && e.response.data) e.response.data.method = 'GET_CSP'
		   store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		  })
		})
  
	  } catch (e) {
		if(e && e.response && e.response.data) e.response.data.method = 'GET_CSP';
		store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
		throw e
	  }
	},*/

	async GetCSP(query) {
		try {
			let data = qs.stringify(query)
			return new Promise(async (resolve, reject) => {
				const response = await axios.post(ApiMethods.GET_CSP, data, {
					headers: {
						'token': store.getters.RootToken
					}
				});
				if (response.data.MajorCode === '000') {
					resolve(response.data)
				} else {
					response.data.method = 'GET_SIM_LOCATION'
					store.commit('SET_ERROR', response.data)
					reject()
				}
			})

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_CSP';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},

	async GetSSP(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_SSP, data);
			if (response.data.MajorCode === '000') {
				return response.data.Data
			} else {
				response.data.method = 'GET_SSP';
				store.commit('SET_ERROR', response)
				return false
			}
		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_SSP';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetAssetInfo(query) {
		try {
			//let data = qs.stringify(query)
			const response = await axios.get(ApiMethods.GET_ASSET_INFO, {
				params: query,
			});
			//console.log(response)
			if (response.data.MajorCode === '000') {
				return response.data.Data && response.data.Data.Assets && response.data.Data.Assets[0] ? response.data.Data.Assets[0] : {}
			} else {
				response.data.method = 'GET_ASSET_INFO';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_ASSET_INFO';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	async GetDashboardInfo(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_DASHBOARD, data);
			//console.log(response)
			if (response.data.MajorCode === '000' && !isObjEmpty(response.data.Data)) {

				store.commit('SET_ALL_SOLUTION_STATS', response.data.Data.Total.length ? response.data.Data.Total : [])
				store.commit('SET_ACTIVATED_IN_PAST_PERIOD', response.data.Data.Past14days.length ? response.data.Data.Past14days : [])
				store.commit('SET_ACTIVATED_PER_DAY', response.data.Data.Daily.length ? response.data.Data.Daily : [])
				store.commit('SET_ALL_SIMS_STATES', response.data.Data.Sims.length ? SortArrayByObjProps(response.data.Data.Sims, [{ prop: 'SimStatus', direction: 1 }]) : [])

				return response.data.Data
			} else {
				response.data.method = 'GET_DASHBOARD';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_DASHBOARD';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	/*async GetDashboardInfo2(query){
	  try {
		let data = qs.stringify(query)
		const response = await axios.post(ApiMethods.GET_DASHBOARD2, data);
		//console.log(response)
		if (response.data.MajorCode === '000' && !isObjEmpty(response.data.Data)) {
  
		  store.commit('SET_ACTIVATED_DEVICES', response.data.Data.DevicesSold ? response.data.Data.DevicesSold : {})
  
		  return response.data.Data
		}else{
		  response.data.method = 'GET_DASHBOARD2';
		  store.commit('SET_ERROR', response.data)
		  return false
		}
  
	  } catch (e) {
		if(e && e.response && e.response.data) e.response.data.method = 'GET_DASHBOARD2';
		store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
		throw e
	  }
	},*/
	async GetUsageOverview(query) {
		try {
			let data = qs.stringify(query)
			const response = await axios.post(ApiMethods.GET_USAGE_OVERVIEW, data);

			if (response.data.MajorCode === '000' && !isObjEmpty(response.data.Data)) {
				store.commit('SET_USAGE_OVERVIEW', response.data.Data ? response.data.Data : {})

				return response.data.Data
			} else {
				response.data.method = 'GET_USAGE_OVERVIEW';
				store.commit('SET_ERROR', response.data)
				return false
			}

		} catch (e) {
			if (e && e.response && e.response.data) e.response.data.method = 'GET_USAGE_OVERVIEW';
			store.commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		}
	},
	/*async GetActivatedDevices(query){
	  try {
		let data = qs.stringify(query)
		const response = await axios.post(ApiMethods.GET_ACTIVATED_DEVICES, data);
  
		if (response.data.MajorCode === '000') {
  
		  return response.data.Data
		}else{
		  response.data.method = 'GET_ACTIVATED_DEVICES';
		  store.commit('SET_ERROR', response.data)
		  return false
		}
  
	  } catch (e) {
		if(e && e.response && e.response.data) e.response.data.method = 'GET_ACTIVATED_DEVICES';
		store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
		throw e
	  }
	},*/
}